var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimOnline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9h17m0 3.417V6a2 2 0 00-2-2H5a2 2 0 00-2 2v11a2 2 0 002 2h8.418m3.952-.23L19.13 17l-1.76-1.77M5.8 6.5h.01m2.5 0h.01m2.5 0h.01m10.705 6.964a5 5 0 11-7.07 7.072 5 5 0 017.07-7.072z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgClaimOnline;